<div class="userDetailContainer animateH5">
      <div class="header hdr">
        <div class="d-flex">
            <h5 class="animateClass"> <span class="animateH5">{{userDetailInput?.username}}</span>
            </h5>
            @if(currentUserDetail?.role=="Admin"){
            <ul class="list-group list-group-horizontal IconClass" *ngIf="!passwordFormShow">
                <li class="list-group-item">
                    <a [attr.disabled]="userDetailInput?.role === 'Admin'"
                        [ngClass]="userDetailInput?.role === 'Admin'? 'disableClass':''"
                        *ngIf="userDetailInput?.is_active" class="listIcon" tooltip="Deactivate"
                        [options]="myOptions">
                        <i class="fa fa-ban" aria-hidden="true" (click)="deactivateUserFun(userDetailInput)"></i>
                    </a>
                    <a [attr.disabled]="userDetailInput?.role === 'Admin'"
                        [ngClass]="userDetailInput?.role === 'Admin'? 'disableClass':''"
                        *ngIf="!userDetailInput?.is_active" class="listIcon" tooltip="Activate"
                        [options]="myOptions">
                        <i class="fa fa-check" aria-hidden="true" (click)="deactivateUserFun(userDetailInput)"></i>
                    </a>
                </li>
                <li class="list-group-item">
                    <a [attr.disabled]="userDetailInput?.role === 'Admin'"
                        [ngClass]="userDetailInput?.role === 'Admin'? 'disableClass':''"
                        class="listIcon" tooltip="Reset Password" [options]="myOptions">
                        <i class="fa fa-lock" aria-hidden="true" (click)="openPasswordForm()"></i></a>
                </li>
                <li class="list-group-item">
                    <a [attr.disabled]="userDetailInput?.role === 'Admin'"
                        [ngClass]="userDetailInput?.role === 'Admin'? 'disableClass':''"
                        aria-disabled="true" class="listIcon" tooltip="Delete" [options]="myOptions">
                        <i class="fa fa-trash" aria-hidden="true" (click)="deleteUserFun(userDetailInput)"
                            data-bs-toggle="modal" data-bs-target="#exampleModal"></i></a>
                </li>
            </ul>
          }
        </div>
    </div>
       <form [formGroup]="userDetailsForm" *ngIf="!passwordFormShow">
        <div class="container userFormContainer">
            <div class="row">
                <div class="col-md-8 offset-md-2">
                    <div class="card userDetailsCard">
                        <div class="row">
                            <div class="col-md-12">
                                <h4 class="userHeading border">User Details</h4>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="form-label mandatoryLabel">User Name <i
                                            class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                    <input type="text" class="form-control" formControlName="username" name="username"
                                        id="name">
                                        <span class="text-danger"
                                        *ngIf="userDetailsForm.controls['username'].invalid && userDetailsForm.controls['username'].dirty && userDetailsForm.hasError('required','username')">
                                        User name is required.
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="form-label mandatoryLabel">User Role <i
                                            class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                    <!-- <select *ngIf="!getRole" type="text" class="{{adminClass}} select1"
                                        formControlName="role" name="role" id="role">
                                        <option value="Admin">Admin</option>
                                        <option value="Agent">Agent</option>
                                    </select> -->
                                    <select class="form-control select2" formControlName="role"
                                        name="role" id="role" (change)="selectRole($event)">
                                       
                                        <ng-container *ngIf="roleList.length > 0">
                                            <ng-container *ngFor="let roles of roleList">
                                                <option *ngIf="roles.is_active" value="{{roles.name}}">{{roles.name}}</option>
                                            </ng-container>
                                        </ng-container>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="form-label mandatoryLabel">Email <i
                                            class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                    <input type="text" class="form-control"  
                                        formControlName="email" name="email" id="email">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="form-label mandatoryLabel">Phone Number <i
                                            class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                    <input type="text" class="form-control"  
                                        formControlName="phone_number" name="phone_number" id="phoneno">
                                </div>
                            </div>
                            <div class="col-md-12 text-end">
                                <button class="btn btn-light cancelBtn" type="button" (click)="goBack()">Reset</button>
                                <button class="btn btn-primary updateBtn" type="submit"
                                    [disabled]="!userDetailsForm.dirty && !spinner" (click)="updateUserDetails()"><i
                                        class="fa fa-spinner fa-pulse fa-3x fa-fw" *ngIf="spinner">
                                        <span class="sr-only">Loading...</span>
                                    </i>Update</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
     <form [formGroup]="passwordForm" *ngIf="passwordFormShow">
        <div class="container userFormContainer">
            <div class="row">
                <div class="col-md-6 offset-md-2">
                    <div class="card userDetailsCard">
                        <div class="row">
                            <div class="col-md-12">
                                <h4 class="userHeading">Password Reset</h4>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="form-label mandatoryLabel"
                                        [ngClass]="{ 'is-invalid': submitted && f['password'].errors }">New Password<i
                                            class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                    <div class="input-field">
                                        <input [type]="type" class="form-control" formControlName="password"
                                            name="password" id="password">
                                        <span class="fa {{eyeIcon}} passwordEye" (click)="hideShowPassword()"></span>
                                    </div>
                                    <div *ngIf="submitted && f['password'].errors" class="invalid-feedback">
                                        <div class="text-danger"
                                            *ngIf="f['password'].errors['required'] && f['password'].invalid">New
                                            Password is required</div>
                                        <div class="text-danger" *ngIf="f['password'].errors['minlength']">
                                            Password must be at least 8 characters
                                        </div>
                                        <div class="text-danger" *ngIf="f['password'].errors['pattern']">Password must
                                            contain a number and At least 1 character from[ _ or &#64; or $ ].</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="form-label mandatoryLabel">Confirm Password<i
                                            class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                    <input type="password"
                                        [ngClass]="{ 'is-invalid': submitted && f['confirmPassword'].errors && f['confirmPassword'].invalid}"
                                        class="form-control" formControlName="confirmPassword" name="confirmPassword"
                                        id="confirmPassword">
                                    <div class="text-danger"
                                        *ngIf="submitted && f['confirmPassword'].errors && f['confirmPassword'].invalid"
                                        class="invalid-feedback">
                                        <div class="text-danger"
                                            *ngIf="f['confirmPassword'].errors['required'] && f['confirmPassword'].invalid">
                                            Confirm Password is required
                                        </div>
                                        <div class="text-danger" *ngIf="f['confirmPassword'].errors['matching']">
                                            Confirm Password doesn't match.Please re-enter your password.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 text-end">
                                <button class="btn btn-light cancelBtn" type="button"
                                    (click)="hidePasswordForm()">Cancel</button>
                                <button class="btn btn-primary updateBtn" type="submit"
                                    [disabled]="!passwordForm.dirty && !spinner" (click)="onSubmit()"><i
                                        class="fa fa-spinner fa-pulse fa-3x fa-fw" *ngIf="spinner">
                                        <span class="sr-only">Loading...</span>
                                    </i>Update</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>


<p-toast position="top-right"></p-toast>